import { render, staticRenderFns } from "./ManutenzioneRecursiva.vue?vue&type=template&id=e27643ec&scoped=true&"
import script from "./ManutenzioneRecursiva.vue?vue&type=script&lang=js&"
export * from "./ManutenzioneRecursiva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27643ec",
  null
  
)

export default component.exports